"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeChangeAddressBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var moment = require("moment");
var ChangeAddressModal_1 = require("./mta/ChangeAddressModal");
var AnnualHomeChangeAddressBanner = /** @class */ (function (_super) {
    __extends(AnnualHomeChangeAddressBanner, _super);
    function AnnualHomeChangeAddressBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showWarningPopup: false
        };
        _this.toggleWarningPopUp = _this.toggleWarningPopUp.bind(_this);
        return _this;
    }
    AnnualHomeChangeAddressBanner.prototype.render = function () {
        var _this = this;
        var uiState = this.props.interaction.uistate;
        var allowAddressChange = uiState.minMtaStartDate ? moment(uiState.maxMtaStartDate).isSameOrAfter(moment(uiState.minMtaStartDate)) : true;
        var changesMade = uiState.interactionChangesDetected === true;
        if (!allowAddressChange) {
            return null;
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "banner banner-info", children: [(0, jsx_runtime_1.jsx)(ChangeAddressModal_1.ChangeAddressModal, __assign({}, this.props, { isOpen: this.state.showWarningPopup, toggle: this.toggleWarningPopUp })), (0, jsx_runtime_1.jsxs)("div", { className: "banner-text", children: [(0, jsx_runtime_1.jsx)("p", { children: "Changing your address?" }), (0, jsx_runtime_1.jsxs)("p", { children: ["Please select", ' ', (0, jsx_runtime_1.jsx)("b", { children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn-text", onClick: function (e) {
                                            if (changesMade) {
                                                e.preventDefault();
                                                _this.setState({ showWarningPopup: true });
                                            }
                                            else {
                                                _this.executeEvent("change");
                                            }
                                        }, children: "Change address" }) }), ' ', "before making any other changes. You\u2019ll be asked to review and update your cover as part of that journey."] })] })] }));
    };
    AnnualHomeChangeAddressBanner.prototype.toggleWarningPopUp = function () {
        this.setState(function (state) { return ({
            showWarningPopup: !state.showWarningPopup
        }); });
    };
    return AnnualHomeChangeAddressBanner;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeChangeAddressBanner = AnnualHomeChangeAddressBanner;
//# sourceMappingURL=AnnualHomeChangeAddressBanner.js.map